import { Suspense } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Eye, EyeOff, Sparkles, UserRound } from "lucide-react";
import { BottomNav } from "@/components/layout/BottomNav";
import { Fab } from "@/components/layout/Fab";
import { PageTransition } from "@/components/motion/PageTransition";
import { NotificationBell } from "@/features/notifications/NotificationBell";
import { useCouple } from "@/hooks/useCouple";

export const AppShell = () => {
  const location = useLocation();
  return (
    <div className="min-h-dvh bg-[var(--cream)]">
      <main className="mx-auto w-full max-w-md px-5 pt-4 safe-bottom">
        <Suspense fallback={<div className="pt-24 text-center serif text-xl text-[var(--coffee-muted)] animate-pulse">…</div>}>
          <AnimatePresence mode="wait" initial={false}>
            <PageTransition key={location.pathname}>
              <Outlet />
            </PageTransition>
          </AnimatePresence>
        </Suspense>
      </main>
      <Fab />
      <BottomNav />
    </div>
  );
};

export const TopBar = ({ title, eyebrow, back }) => {
  const nav = useNavigate();
  const { discreet, toggleDiscreet } = useCouple();
  return (
    <header className="flex items-center justify-between mb-6">
      <div className="min-w-0">
        {back ? (
          <button className="btn-ghost -ml-3 h-10" onClick={() => nav(back)} data-testid="topbar-back-button">← voltar</button>
        ) : eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
        {title && <h1 className="serif text-3xl leading-none text-[var(--coffee)] mt-1 truncate">{title}</h1>}
      </div>
      <div className="flex items-center gap-1 shrink-0">
        <NotificationBell />
        <button onClick={() => nav("/assistente")} data-testid="assistente-open-button"
          className="w-11 h-11 rounded-full flex items-center justify-center text-[var(--teal)] hover:bg-[var(--teal-light)] transition-colors" aria-label="Assistente IA">
          <Sparkles size={20} />
        </button>
        <button onClick={toggleDiscreet} data-testid="discreet-mode-toggle" aria-pressed={discreet}
          className="w-11 h-11 rounded-full flex items-center justify-center text-[var(--coffee-medium)] hover:bg-[var(--cream-surface)] transition-colors" aria-label="Modo discreto">
          {discreet ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
        <button onClick={() => nav("/perfil")} data-testid="profile-button"
          className="w-11 h-11 rounded-full flex items-center justify-center text-[var(--coffee-medium)] hover:bg-[var(--cream-surface)] transition-colors" aria-label="Perfil">
          <UserRound size={20} />
        </button>
      </div>
    </header>
  );
};
